import { createFileRoute, redirect } from "@tanstack/react-router";

import { loadNamespaces } from "../../app/i18n";
import { legacyAppTarget } from "../../app/legacy";
import { SellerShell } from "../../areas/seller/shell/SellerShell";
import { guard } from "../../shared/auth/guards";
import { SellerNotFound } from "../../shared/layout/NotFound";
import { RouteError } from "../../shared/layout/RouteError";

/** Seller area layout: prototype hash URLs first (FR-FE01-08), guard `seller`, then the shell. */
export const Route = createFileRoute("/app/_seller")({
  beforeLoad: async (args) => {
    const { pathname, hash, searchStr } = args.location;
    const legacy = legacyAppTarget(pathname, hash, searchStr);
    if (legacy) throw redirect({ href: legacy, replace: true });
    await Promise.all([guard("seller", args), loadNamespaces("seller")]);
  },
  component: SellerShell,
  errorComponent: RouteError,
  notFoundComponent: SellerNotFound,
});
